import {defineStore} from "pinia";
import {useAuthStore} from "@/stores/authStores";
import api from '@/services/api'
import {useContactsStore} from "@/stores/contactsStore";

export const useSDSStore = defineStore('sds', {
    state: () => ({
        messages: [],

        history: [], // to be fetched from BE

        selectedMessage: [], // to be set when a message is selected
    }),

    getters: {
        getLatest() {
            return this.messages.length > 0 ? this.messages[0] : null;
        }
    },


    actions: {
        acknowledge() {
            var ids = [];
            this.selectedMessage.forEach(msg => {
                ids.push(msg.value.id);

            });
            api.put(
                '/sds/acknowledge',
                {},
                {
                    headers: {'Content-Type': 'application/json'},
                    params: {ids: ids.join(',')}
                }
            )
                .then(() => {
                    this.fetchInbox();
                    this.fetchHistory();
                })
                .catch(error => {
                    console.error("There was an error adding the message to db:", error);
                });
            this.selectedMessage = []; // clear the selected message
        },

        acknowledgeAll() {
            var ids = [];
            this.messages.forEach(msg => {
                ids.push(msg.id);

            });
            api.put(
                '/sds/acknowledge',
                {},
                {
                    headers: {'Content-Type': 'application/json'},
                    params: {ids: ids.join(',')}
                }
            )
                .then(() => {
                    this.fetchInbox();
                    this.fetchHistory();
                })
                .catch(error => {
                    console.error("There was an error adding the message to db:", error);
                });
            this.selectedMessage = []; // clear the selected message

        },

        searchContact(isdn) {
            // first check if the caller a handheld
            const contactsStore = useContactsStore();
            const hhIndex = contactsStore.handheld.findIndex(hh => hh.isdn === isdn);
            if (hhIndex !== -1) {
                return contactsStore.handheld[hhIndex].radioId;
            } else {
                api.get('/train/getTrainDetailByIsdn', {
                    params: {
                        user: isdn
                    }
                })
                    .then(response => {
                        if (response.data !== "") {
                            return response.data.trainId
                        } else {
                            return "Unknown (" + isdn + ")";
                        }
                    })
                    .catch(error => {
                        console.error("There was an error fetching data of the caller:", error);
                        return "Unknown (" + isdn + ")";
                    });
            }

        },

        onMessageIn(data) {
            this.fetchInbox();
            const newMessage = {
                id: data.value.msgid,
                sender: data.value.from,
                receiver: data.value.to,
                senderName: this.searchContact(data.value.from),
                receiverName: useAuthStore().loggedUserProfile,
                time: Date.now(),
                message: data.value.content,
                ack: false,
            };

            api.post(
                '/sds/newMsg',
                newMessage,
                {headers: {'Content-Type': 'application/json'}}
            )
                .then(() => {
                    this.fetchInbox();
                })
                .catch(error => {
                    console.error("There was an error adding the message to db:", error);
                });
        },

        onMessageSent(data) {
            const newOutgoingMessage = {
                id: data.value.msgid,
                sender: data.value.from,
                receiver: data.value.to,
                senderName: useAuthStore().loggedUserProfile,
                receiverName: this.searchContact(data.value.to),
                time: Date.now(),
                message: data.value.content,
                ack: false,
            };

            api.post(
                '/sds/newMsg',
                newOutgoingMessage,
                {headers: {'Content-Type': 'application/json'}}
            )
                .then(() => {
                    this.fetchHistory();
                })
                .catch(error => {
                    console.error("There was an error adding the message to db:", error);
                });
        },

        fetchHistory() {
            api.get('/sds/getHistory', {
                params: {
                    user: useAuthStore().loggedUser
                }
            })
                .then(response => {
                    this.history = response.data;
                })
                .catch(error => {
                    console.error("There was an error fetching the call history:", error);
                });
        },

        fetchInbox() {
            api.get('/sds/getInbox', {
                params: {
                    user: useAuthStore().loggedUser
                }
            })
                .then(response => {
                    this.messages = response.data;
                })
                .catch(error => {
                    console.error("There was an error fetching the call history:", error);
                });
        },
    },
})